<div class="container px-3 px-xl-0 pb-5">
  <app-navigation-container />
</div>
@if (('feature.recommendations' | feature)) {
  <div>
    <app-recommendation />
  </div>
}

@if (('hide.hgapp.apple' | feature) === false || ('hide.hgapp.google' | feature) === false) {
  <div class="container px-lg-0">
    <app-advertisment [isocode]="isocode" />
  </div>
}
